import { GetTxfJobResponse } from '@taxfyle/api-internal/internal/txf_pb'
import { timestampToISO } from 'utils/grpc-util'

export interface TxfJobDTO {
  job_id: string
  create_time: string | undefined
  update_time: string | undefined
}

export function mapTxfJobProtoToDTO(proto: GetTxfJobResponse): TxfJobDTO {
  return {
    job_id: proto.getJobId(),
    create_time: timestampToISO(proto.getCreateTime()),
    update_time: timestampToISO(proto.getUpdateTime()),
  }
}
